export default "__VITE_PUBLIC_ASSET__bf614ddd__"